import {
  CommunicationSearch,
  CommunicationSearchProps,
  SectionHeading,
} from "@/components";

type Props = {
  title: string;
  tags?: Array<{ title: string; href: string }>;
  searchProps: CommunicationSearchProps;
};

export const CommunicationSearchSection = ({
  title,
  /* tags, */
  searchProps,
}: Props) => {
  return (
    <section className="d-flex flex-column gap-x28">
      <SectionHeading
        className="title"
        title={title}
        titleMarginBottom="mb-x0"
      />
      <CommunicationSearch {...searchProps} />
      {/* tags && <TagsSection /> */}
    </section>
  );
};
